import React from 'react';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import PageHeader from '../../components/banners/page-header';
import StartTrialBanner from '../../components/banners/start-trial';
import LoginStore from '../../stores/login-store';
import './credits.scss';

const ICON_AUTHORS = [
  ['Freepik', 'https://www.freepik.com/'],
  ['Eucalyp', 'https://www.flaticon.com/authors/eucalyp'],
  ['Smartline', 'https://www.flaticon.com/authors/smartline'],
  ['Nikita Golubev', 'https://www.flaticon.com/authors/nikita-golubev'],
  ['Smashicons', 'https://www.flaticon.com/authors/smashicons'],
  ['dDara', 'https://www.flaticon.com/authors/ddara'],
  ['kiranshastry', 'https://www.flaticon.com/authors/kiranshastry'],
];

export default function CreditsPage(props) {
  let trialBanner = (LoginStore.isLoggedIn()) ? null : <StartTrialBanner {...props} />

  return (
    <div>
      <SEOHead {...SEO_CONFIG.credits} />
      <PageHeader eyebrow="About" title="Site credits">
        <p>The people behind Neurochecklists.</p>
      </PageHeader>

      <div className="page-content credits-grid">
        <div className="credits-card">
          <h2 className="credits-card-title">Made by</h2>
          <dl className="credits-list">
            <dt>Data curator</dt>
            <dd><a href="https://www.linkedin.com/in/ibrahimimam2000/" target="_blank" rel="noopener noreferrer">Dr. Ibrahim Imam, FRCP</a></dd>
            <dt>Development</dt>
            <dd><a href="https://petermellett.co.uk" target="_blank" rel="noopener noreferrer">Peter Mellett</a></dd>
            <dt>Design</dt>
            <dd><a href="https://www.infusedmedia.co.uk/" target="_blank" rel="noopener noreferrer">Infused Media</a></dd>
            <dt>Original proof-of-concept</dt>
            <dd><a href="http://studio14online.co.uk" target="_blank" rel="noopener noreferrer">Studio 14</a></dd>
          </dl>
        </div>

        <div className="credits-card">
          <h2 className="credits-card-title">Icons</h2>
          <ul className="credits-icons">
            {ICON_AUTHORS.map(([name, url]) => (
              <li key={name}><a href={url} title={name}>{name}</a></li>
            ))}
          </ul>
          <p className="credits-note">
            From <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a>, licensed under <a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank" rel="noopener noreferrer">CC BY 3.0</a>.
          </p>
        </div>
      </div>
      {trialBanner}
    </div>
  );
}
